import * as z from "zod";

export function optionalHappyReturnsField<T>(schema: z.ZodType<T>) {
  return schema
    .nullish()
    .transform((value): T | undefined => value ?? undefined)
    .optional();
}
